import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Dialog, DialogActions, DialogContent, Button, withStyles } from 'material-ui';

import styles from 'shared/styles/components/DatepickerModal';

@withStyles(styles)
@observer
export default class DatepickerModal extends Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired
  }

  static defaultProps = {
    open: false
  }

  render() {
    const { children, onClose, onAccept, onClear, classes, ...other } = this.props;

    return (
      <Dialog onClose={ onClose } classes={{ paper: classes.dialogRoot }} { ...other }>

        <DialogContent className={ classes.dialog }>
          { children }
        </DialogContent>

        <DialogActions className={ classes.dialogActions }>
          <div>

            <Button
              disableFocusRipple
              color="primary"
              onClick={ onClear }
              tabIndex={-2}
            >
              Сброс
            </Button>

          </div>
          <div>

            <Button
              disableFocusRipple
              color="primary"
              onClick={ onClose }
              tabIndex={-1}
            >
              Отмена
            </Button>

            <Button
              disableFocusRipple
              color="primary"
              onClick={ onAccept }
            >
              ОК
            </Button>

          </div>
        </DialogActions>

      </Dialog>
    );
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/DatepickerModal.js